<div class="pwa-install-banner" *ngIf="showBanner" [@slideDown]>
  <div class="banner-content">
    <div class="banner-icon">
      <i class="fas fa-mobile-alt"></i>
    </div>

    <div class="banner-text">
      <h4 class="banner-title">{{ 'PWA.TITLE' | translate }}</h4>
      <p class="banner-description" *ngIf="!isIOS">
        {{ 'PWA.DESCRIPTION' | translate }}
      </p>
      <p class="banner-description" *ngIf="isIOS" [innerHTML]="'PWA.IOS_INSTRUCTIONS' | translate"></p>
    </div>

    <div class="banner-actions">
      <button class="btn btn-install" (click)="onInstallClick()"
        [attr.aria-label]="isIOS ? ('PWA.ARIA_INSTRUCTIONS' | translate) : ('PWA.ARIA_INSTALL' | translate)">
        <i class="fas fa-download" *ngIf="!isIOS"></i>
        <i class="fas fa-info-circle" *ngIf="isIOS"></i>
        {{ (isIOS ? 'PWA.HOW_TO_INSTALL_BUTTON' : 'PWA.INSTALL_BUTTON') | translate }}
      </button>

      <button class="btn btn-close" (click)="onCloseClick()" [attr.aria-label]="'PWA.ARIA_CLOSE' | translate"
        [title]="'PWA.CLOSE_TITLE' | translate">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
</div>